// extracted by mini-css-extract-plugin
module.exports = {"link-button":"_9e1425b4d3--link-button--Pewgf"};